// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_il-1";
export var rowFirst = "_il-3";
export var rowLast = "_il-5";
export var rowMiddle = "_il-4";
export var ticketListScroll = "_il-2";
export var ticketStack = "_il-0";